<template>
  <div class="flex flex-wrap w-full max-w-xl mx-auto">
    <div class="w-full md:w-1/2 item-outer col p-3">
      <div class="border h-full flex flex-col justify-between items-center rounded item_border item_border_arrow relative border_main11">
        <div class="p-2 w-full gept_main_bg">
          <p class="font-bold text-white md:text-lg text-center">音檔播放測試</p>
        </div>
        <div class="item_img p-2 mb-1 cursor-pointer">
          <div>
            <img src="@/assets/image/gept/play_test.png" alt="" class="" v-if="!isPlayingAudio" @click="audio_play">
            <img src="@/assets/image/gept/play_test_on.png" alt="" class="" v-else @click="audio_stop">
          </div>
        </div>

        <div class="p-3">
          <p class="gept_main_color md:text-lg text-center font-semibold">請點選播放後，確認聲音播放是否正常。</p>
        </div>
      </div>
    </div>
    <div class="w-full md:w-1/2 item-outer col p-3">
      <div class="border h-full flex flex-col justify-between items-center rounded item_border item_border_arrow relative border_main11">
        <div class="p-2 w-full gept_main_bg">
          <p class="font-bold text-white md:text-lg text-center" >麥克風測試</p>
        </div>
        <div class="item_img p-2 mb-1 flex justify-center">
          <div class="border border_main4 rounded-full p-2 cursor-pointer" @click="toggleRecord">
            <div class="record_img">
              <canvas id="canvas" ref="recordRefTest" class="canvas canvas_test"></canvas>
            </div>
          </div>
        </div>

        <div class="p-3">
          <p class="gept_main_color md:text-lg text-center font-semibold">請對著麥克風說話，線條產生波動，代表麥克風正常。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Recorder from 'js-audio-recorder'
let recorderJS = new Recorder()
export default {
  name: 'TestingTools',
  props: {
    questionData: {
      type: Object
    }
  },
  data () {
    return {
      audioData: null,
      sound_effect: null,

      isPlayingAudio: false,
      isRecording: false
    }
  },
  computed: {
  },
  watch: {
  },
  mounted () {
    this.setAudio()

    navigator.mediaDevices.getUserMedia({ audio: true })

    this.setTimeoutFun()
  },
  beforeDestroy () {
    if (this.isPlayingAudio || this.sound_effect && this.sound_effect.currentTime > 0) {
      this.audio_stop()
    }
    if (this.isRecording) {
      this.stopRecord()
    }
  },
  methods: {
    cleanTimeOut () {
      let self = this
      clearTimeout(self.timeOutProcessId)
    },
    setTimeoutFun () {
      let self = this
      self.timeOutProcessId = setTimeout(() => {
        self.toggleRecord()
      }, 1000)
    },
    // 播放測試
    setAudio () {
      let self = this

      if (self.questionData) {
        if (self.questionData.DescriptionAudioUrl) {
          self.sound_effect = new Audio(self.questionData.DescriptionAudioUrl)
        } else {
          self.sound_effect = new Audio(self.questionData.Questions[0].AudioUrl)
        }
      }
    },

    audio_play () {
      let self = this

      if (!self.isPlayingAudio) {
        self.isPlayingAudio = true
        self.sound_effect.play()

        self.sound_effect.addEventListener('ended', () => {
          self.audio_stop()
        })
      }
    },

    audio_stop () {
      let self = this
      self.isPlayingAudio = false
      self.sound_effect.pause()
      self.sound_effect.currentTime = 0
    },

    // 錄音測試
    toggleRecord () {
      let self = this
      if (!self.isRecording) {
        self.startRecord()
      } else {
        self.clickStopRecord()
      }
    },

    startRecord () {
      let self = this
      if (!self.isRecording) {
        recorderJS = new Recorder()
        recorderJS.start().then(() => {
          self.drawRecord()
          self.isRecording = true
        }, (error) => {
          console.log(error)
          recorderJS.stop()

          self.isRecording = false
        })
      }
    },
    clickStopRecord () {
      let self = this

      recorderJS.stop()

      self.audioData = recorderJS.getWAVBlob()

      self.isRecording = false

      // self.playRecord()
    },
    stopRecord () {
      let self = this

      recorderJS.stop()

      self.isRecording = false
    },

    playRecord () {
      recorderJS.play()
    },

    drawRecord () {
      let self = this

      self.drawRecordId = requestAnimationFrame(self.drawRecord)
      self.drawWave({
        canvas: self.$refs.recordRefTest,
        dataArray: recorderJS.getRecordAnalyseData(),
        bgcolor: 'rgb(200, 200, 200, 0)',
        lineWidth: 2,
        lineColor: 'rgb(255, 255, 255)'
      })
    },

    drawWave({
      canvas,
      dataArray,
      bgcolor = 'rgb(200, 200, 200)',
      lineWidth = 2,
      lineColor = 'rgb(0, 0, 0)'
    }) {
      if (!canvas) return
      canvas.width = 144;
      canvas.height = 144;

      let background = new Image()
      background.src = require('@/assets/image/gept/recording_img2.png')
      background.size = 'contain'

      const ctx = canvas.getContext('2d')
      const bufferLength = dataArray.length
      const sliceWidth = canvas.width / bufferLength
      let x = 0
      ctx.drawImage(background, 0, 0)
      ctx.fillStyle = bgcolor
      ctx.fillRect(0, 0, canvas.width, canvas.height)

      ctx.lineWidth = lineWidth
      ctx.strokeStyle = lineColor

      ctx.beginPath()

      for (let i = 0; i < bufferLength; i++) {
        const v = dataArray[i] / 128
        const y = (v * canvas.height) / 2

        if (i === 0) {
          ctx.moveTo(x, y)
        } else {
          ctx.lineTo(x, y)
        }
        x += sliceWidth
      }

      ctx.lineTo(canvas.width, canvas.height / 2)
      ctx.stroke()
    }
  }
}
</script>
<style lang="scss" scoped>
.item_img {
  max-width: 178px;
  max-height: 178px;
}
.record_img {
  width: 144px;
  height: 144px;
  background-image: url('~@/assets/image/gept/recording_img2.png');
  background-size: 144px;
}
.canvas_test {
  width: 100%;
  height: 100%;
  max-width: 144px;
  max-height: 144px;
}
</style>
